import { ArrowDownRight, ArrowUpRight, Eye, Mail, MessageCircle, Minus, Trophy, Users } from "lucide-react";

export const PERIODS = [
  ["today", "Today"],
  ["7d", "7 days"],
  ["30d", "30 days"],
  ["90d", "90 days"],
  ["all", "All time"],
];

export const PeriodSelect = ({ value, onChange, testid }) => (
  <select value={value} onChange={(e) => onChange(e.target.value)} data-testid={testid}
    className="rounded-full border border-[#E5D9CF] bg-white px-3 py-1.5 text-[11px] font-semibold text-[#5A504B] outline-none focus:border-[#C9A24B]">
    {PERIODS.map(([v, l]) => <option key={v} value={v}>{l}</option>)}
  </select>
);

// Small ▲/▼ trend badge comparing current vs previous period.
const Trend = ({ cur, prev }) => {
  if (prev === undefined || prev === null) return null;
  const c = Number(cur) || 0, p = Number(prev) || 0;
  if (p === 0 && c === 0) return null;
  const pct = p === 0 ? 100 : Math.round(((c - p) / p) * 100);
  const flat = c === p;
  const up = c > p;
  const Icon = flat ? Minus : up ? ArrowUpRight : ArrowDownRight;
  const cls = flat ? "text-[#A99C90]" : up ? "text-emerald-600" : "text-rose-500";
  return (
    <span className={`mt-1 inline-flex items-center gap-0.5 text-[10px] font-semibold ${cls}`} title={`vs previous period (${p})`}>
      <Icon className="h-3 w-3" aria-hidden="true" />{flat ? "0%" : `${Math.abs(pct)}%`}
    </span>
  );
};

// Per-brand performance strip: visits, enquiries, WhatsApp chats, leads, win rate.
export const AnalyticsStrip = ({ metrics, accent = "#C9A24B", testid }) => {
  if (!metrics) return null;
  const prev = metrics.prev || null;
  const tiles = [
    { k: "visits", label: "Visits", Icon: Eye, val: metrics.visits, raw: metrics.visits },
    { k: "enquiries", label: "Enquiries", Icon: Mail, val: metrics.enquiries, raw: metrics.enquiries },
    { k: "chats", label: "WhatsApp Chats", Icon: MessageCircle, val: metrics.chats, raw: metrics.chats },
    { k: "leads", label: "Leads", Icon: Users, val: metrics.leads, raw: metrics.leads },
  ];
  if (metrics.win_rate !== null && metrics.win_rate !== undefined) {
    tiles.push({ k: "win", label: "Win Rate", Icon: Trophy, val: `${metrics.win_rate}%`, raw: metrics.win_rate });
  }
  return (
    <div className={`grid grid-cols-2 gap-px bg-[#E8E2D9] ${tiles.length === 5 ? "sm:grid-cols-5" : "sm:grid-cols-4"}`} data-testid={testid}>
      {tiles.map(({ k, label, Icon, val, raw }) => (
        <div key={k} className="flex flex-col items-center bg-[#FAF8F5] px-4 py-4 text-center" data-testid={`metric-${k}`}>
          <Icon className="mb-1 h-4 w-4" style={{ color: accent }} aria-hidden="true" />
          <p className="font-serif text-2xl font-semibold text-[#1A1615]">{val ?? 0}</p>
          <p className="mt-0.5 text-[10px] uppercase tracking-[0.1em] text-[#91837C]">{label}</p>
          {prev && <Trend cur={raw} prev={prev[k === "win" ? "win_rate" : k]} />}
        </div>
      ))}
    </div>
  );
};
